import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css']
})
export class ModalsComponent implements OnInit {

  modelData: any;
  modelName = 'Order';
  modelId = '0';

  constructor(private router: Router, private formBuilder: FormBuilder, private _data: CommonDataService) { 

    //this.modelData = this._data.currentOrder;

  }

  ngOnInit() {
    
  }

  //first check for the modal data that came back from the server... and then we use that to pump the feed for the modal. 

}
